import {useAuthInfo} from "@propelauth/react";
import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { DeveloperProjectModel } from "@models/project";
import { ProjectInfoDeveloper } from "../projects/ProjectInfo";
import FilesView from "../files/FilesView";
import {DeveloperBidSummarySD } from "../bid/bid_summary/DeveloperBidSummaryView";
import QAWidget from "../qa_forum/qa_widget";
import { DeveloperVEWidget } from "../ve/VEWidget";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";
import {DeveloperScopesOverview} from "../scope/developer/ScopeCard";
import {useToast} from "../ui/use-toast";
import {fetchWithToken} from "../../api/apiBase";

function ViewProjectAsDeveloper() {
        const {toast} = useToast();
    const {accessToken} = useAuthInfo()
    const [project, setProject] = useState<DeveloperProjectModel | null>(null);
    const { project_id } = useParams<string>();

    const fileContext = {
        editing: true,
        context: "project",
        permission: "edit",
        parent_id: project_id,
        parent_type: "project",
        project_id: project_id,
        folder_id: project?.root.id,
    };

    const fetchProject = async () => {
        if (project_id) {
            try {
              const data = await fetchWithToken(`/projects/${project_id}`, accessToken as string);
              setProject(data);
                // console.log(data)
            }
            catch (err) {
                toast({
                    title: "Error!",
                    description: "Failed to load project",
                    variant: "destructive",
                });
            };
        }
    }

    useEffect(() => {
        setProject(null);
        fetchProject();
    }, [project_id]);

    if (!project) {
        return <div><BaseLoadingSpinner/></div>;
    }

    return (
        <div className={"container"}>
            
            <br />
            {/*// note - using developerBidderSummary component here which is also used in Developer side.*/}
            {/*//might want to create a separate component for Bidder...*/}
            <ProjectInfoDeveloper project={project} />
            <br />

            {/*//note - using developerBidderSummary component here which is also used in Developer side.*/}
            {/*//might want to create a separate component for Bidder...*/}
            <DeveloperBidSummarySD  />
            {
                project.config.scopes_enabled &&
                    <DeveloperScopesOverview />
            }

            <br />

            <div className="flex gap-4">
                <div className="flex-1 flex flex-col justify-end">
                    <QAWidget renderOnHomePage={true} />
                </div>
                <div className="flex-1 flex flex-col justify-end ">
                    <DeveloperVEWidget ve_summary={project.ve_summary} />
                </div>
            </div>
            {/*// Do not render this component if project is not loaded */}
            <br />
            <FilesView uploadContext={fileContext} />
        </div>
    );
}


// By default, if the user is not logged in they are redirected to the login page
export default ViewProjectAsDeveloper;
